const rawText = `Now(h) on(h) the(h) first(h) day(h) of(h) the(h) week(%) Ma(h)ry(h) Mag(h)da(h)lene(h) came(h) to(h) the(h) tomb(h) ear(h)ly,(h) while(h) it(h) was(h) still(h) dark,(1;) and(h) saw(h) that(h) the(h) stone(h) had(h) been(h) ta(h)ken(h) a(h)way(h) from(h) the(h) tomb.(h) (:)

So(h) she(h) ran,(h) and(h) went(h) to(h) Si(h)mon(h) Pe(h)ter(h) and(h) the(h) o(h)ther(h) di(h)sci(h)ple,(%) the(h) one(h) whom(h) Je(h)sus(h) loved,(1;) and(h) said(h) to(h) them,(h) “They(h) have(h) ta(h)ken(h) the(h) Lord(h) out(h) of(h) the(h) tomb,(1;) and(h) we(h) do(h) not(h) know(h) where(h) they(h) have(h) laid(h) him.”(h) (:)

Pe(h)ter(h) then(h) came(h) out(h) with(h) the(h) o(h)ther(h) di(h)sci(h)ple,(%) and(h) they(h) went(h) to(h)ward(h) the(h) tomb.(h) (:)

They(h) both(h) ran,(h) but(h) the(h) o(h)ther(h) di(h)sci(h)ple(h) out(h)ran(h) Pe(h)ter(h) and(h) reached(h) the(h) tomb(h) first;(%) and(h) stoop(h)ing(h) to(h) look(h) in,(1;) he(h) saw(h) the(h) li(h)nen(h) cloths(h) ly(h)ing(h) there,(h) but(h) he(h) did(h) not(h) go(h) in. (:)

Then(h) Si(h)mon(h) Pe(h)ter(h) came,(h) fol(h)low(h)ing(h) him,(%) and(h) went(h) in(h)to(h) the(h) tomb;(h) (:)

he(h) saw(h) the(h) li(h)nen(h) cloths(h) ly(h)ing,(%) and(h) the(h) nap(h)kin,(h) which(h) had(h) been(h) on(h) his(h) head,(1;) not(h) ly(h)ing(h) with(h) the(h) li(h)nen(h) cloths(h) but(h) rolled(h) up(h) in(h) a(h) place(h) by(h) it(h)self.(h) (:)

Then(h) the(h) o(h)ther(h) di(h)sci(h)ple,(h) who(h) reached(h) the(h) tomb(h) first,(%) al(h)so(h) went(h) in,(h) and(h) he(h) saw(h) and(h) be(h)lieved;(1;) for(h) as(h) yet(h) they(h) did(h) not(h) know(h) the(h) scrip(h)ture,(2;) that(h) he(h) must(h) rise(h) from(h) the(h) dead.(h) (:)

Then(h) the(h) di(h)sci(h)ples(%) went(h) back(h) to(h) their(h) homes.(h) (:)

But(h) Ma(h)ry(h) stood(h) weep(h)ing(h) out(h)side(h) the(h) tomb,(%) and(h) as(h) she(h) wept(h) she(h) stooped(h) to(h) look(h) in(h)to(h) the(h) tomb;(1;) and(h) she(h) saw(h) two(h) an(h)gels(h) in(h) white,(h) sit(h)ting(h) where(h) the(h) bo(h)dy(h) of(h) Je(h)sus(h) had(h) lain,(1;) one(h) at(h) the(h) head(h) and(h) one(h) at(h) the(h) feet.(h) (:)

They(h) said(h) to(h) her,(%) “Wo(h)man,(h) why(h) are(h) you(h) weep(h)ing?”(h) (:)

She(h) said(h) to(h) them,(%) “Be(h)cause(h) they(h) have(h) ta(h)ken(h) a(h)way(h) my(h) Lord,(1;) and(h) I(h) do(h) not(h) know(h) where(h) they(h) have(h) laid(h) him.”(h) (:)

Say(h)ing(h) this,(h) she(h) turned(h) round(h) and(h) saw(h) Je(h)sus(h) stand(h)ing,(%) but(h) she(h) did(h) not(h) know(h) that(h) it(h) was(h) Je(h)sus.(h) (:)

Je(h)sus(h) said(h) to(h) her,(%) “Wo(h)man,(h) why(h) are(h) you(h) weep(h)ing?(h) Whom(h) do(h) you(h) seek?”(h) (:)

Sup(h)pos(h)ing(h) him(h) to(h) be(h) the(h) gard'(h)ner,(%) she(h) said(h) to(h) him,(h) “Sir,(h) if(h) you(h) have(h) car(h)ried(h) him(h) a(h)way,(1;) tell(h) me(h) where(h) you(h) have(h) laid(h) him,(h) and(h) I(h) will(h) take(h) him(h) a(h)way.”(h) (:)

Je(h)sus(h) said(h) to(h) her,(h) “Ma(h)ry.”(%) She(h) turned(h) and(h) said(h) to(h) him(h) in(h) He(h)brew,(2;) “Rab(h)bo(h)ni!”(h) which(h) means(h) Tea(h)cher.(h) (:)

Je(h)sus(h) said(h) to(h) her,(%) “Do(h) not(h) hold(h) me,(h) for(h) I(h) have(h) not(h) yet(h) a(h)scen(h)ded(h) to(h) the(h) Fa(h)ther;(2;) but(h) go(h) to(h) my(h) breth(h)ren(h) and(h) say(h) to(h) them,(1;) I(h) am(h) a(h)scend(h)ing(h) to(h) my(h) Fa(h)ther(h) and(h) your(h) Fa(h)ther,(h) to(h) my(h) God(h) and(h) your(h) God.”(h) (:)

Ma(h)ry(h) Mag(h)da(h)lene(h) went(h) and(h) said(h) to(h) the(h) di(h)sci(h)ples,(%) “I(h) have(h) seen(h) the(h) Lord”;(1;) and(h) she(h) told(h) them(h) that(h) he(h) had(h) said(h) these(h) things(h) to(h) her.(h) (:)

On(h) the(h) eve(h)ning(h) of(h) that(h) day,(%) the(h) first(h) day(h) of(h) the(h) week,(1;) the(h) doors(h) be(h)ing(h) shut(h) where(h) the(h) di(h)sci(h)ples(h) were,(h) for(h) fear(h) of(h) the(h) Jews,(1;) Je(h)sus(h) came(h) and(h) stood(h) a(h)mong(h) them(h) and(h) said(h) to(h) them,(h) “Peace(h) be(h) with(h) you.”(h) (:)

When(h) he(h) had(h) said(h) this,(%) he(h) showed(h) them(h) his(h) hands(h) and(h) his(h) side.(h) (:)

Then(h) the(h) di(h)sci(h)ples(%) were(h) glad(h) when(h) they(h) saw(h) the(h) Lord.(h) (:)

Je(h)sus(h) said(h) to(h) them(h) a(h)gain,(h) “Peace(h) be(h) with(h) you.(%) As(h) the(h) Father(h) has(h) sent(h) me,(h) e(h)ven(h) so(h) I(h) send(h) you.”(h) (:)

And(h) when(h) he(h) had(h) said(h) this,(%) he(h) breathed(h) on(h) them,(h) and(h) said(h) to(h) them,(1;) “Re(h)ceive(h) the(h) Ho(h)ly(h) Spi(h)rit.(h) (:)

If(h) you(h) for(h)give(h) the(h) sins(h) of(h) a(h)ny,(h) they(h) are(h) for(h)gi(h)ven;(%) if(h) you(h) re(h)tain(h) the(h) sins(h) of(h) a(h)ny,(h) they(h) are(h) re(h)tained.”(h)`;

const lines = rawText
    .replace(/\n/g, "")
    .split(" (:)")
    .map((l) => l.trim());

const gabcPhrases = lines.map((line, lineIndex) => {
    const isLastLine = lineIndex === lines.length - 1;

    const firstSplitParts = line.split("(%)");

    const firstPartWords = firstSplitParts[0].split("(h)");

    const omitFirstBreathMark =
        firstPartWords.length === 3 ||
        firstPartWords[firstPartWords.length - 1] === "sci" ||
        firstPartWords[firstPartWords.length - 1] === "ples";

    const firstPartGabc = firstPartWords
        .map((word, wordIndex) => {
            if (wordIndex === 0) {
                return `${word}(jijIHGF)`;
            } else if (wordIndex === 1 && firstPartWords.length === 3) {
                return `${word}(fe)`;
            } else if (wordIndex === 2 && firstPartWords.length === 3) {
                return `${word}(fgh)`;
            } else if (wordIndex === firstPartWords.length - 3) {
                return `${word}(e)`;
            } else if (wordIndex === firstPartWords.length - 2) {
                return `${word}(fg)`;
            } else if (wordIndex === firstPartWords.length - 1) {
                return `${word}(h)`;
            } else {
                return `${word}(f)`;
            }
        })
        .join("");

    const secondSplitParts = firstSplitParts[1].split(";)");

    const secondPartGabc = secondSplitParts
        .map((part) => {
            if (part[part.length - 1] === "1") {
                const secondPartWords = part
                    .replace("(1", "")
                    .split("(h)")
                    .filter((w) => w.length > 0);

                return secondPartWords
                    .map((word, wordIndex) => {
                        if (wordIndex === 0) {
                            return `${word}(f)`;
                        } else if (wordIndex === secondPartWords.length - 3) {
                            return `${word}(g)`;
                        } else if (wordIndex === secondPartWords.length - 2) {
                            return `${word}(f)`;
                        } else if (wordIndex === secondPartWords.length - 1) {
                            return `${word}(h)`;
                        } else {
                            return `${word}(h)`;
                        }
                    })
                    .join("");
            } else if (part[part.length - 1] === "2") {
                const secondPartWords = part
                    .replace("(2", "")
                    .split("(h)")
                    .filter((w) => w.length > 0);

                return secondPartWords
                    .map((word, wordIndex) => {
                        if (wordIndex === 0) {
                            return `${word}(f)`;
                        } else if (wordIndex === secondPartWords.length - 4) {
                            return `${word}(g)`;
                        } else if (wordIndex === secondPartWords.length - 3) {
                            return `${word}(f)`;
                        } else if (wordIndex === secondPartWords.length - 2) {
                            return `${word}(h)`;
                        } else if (wordIndex === secondPartWords.length - 1) {
                            return `${word}(h)`;
                        } else {
                            return `${word}(h)`;
                        }
                    })
                    .join("");
            } else {
                const secondPartWords = part
                    .split("(h)")
                    .filter((w) => w.length > 0);

                return secondPartWords
                    .map((word, wordIndex) => {
                        if (wordIndex === secondPartWords.length - 5) {
                            return `${word}(hij)`;
                        } else if (wordIndex === secondPartWords.length - 4) {
                            return `${word}(i)`;
                        } else if (wordIndex === secondPartWords.length - 3) {
                            return `${word}(hvGFg)`;
                        } else if (wordIndex === secondPartWords.length - 2) {
                            return isLastLine ? `${word}(ef)` : `${word}(e)`;
                        } else if (wordIndex === secondPartWords.length - 1) {
                            return isLastLine ? `${word}(gf)` : `${word}(f)`;
                        } else if (wordIndex === 0) {
                            if (omitFirstBreathMark) {
                                return `${word}(h)`;
                            } else {
                                return `${word}(f)`;
                            }
                        } else {
                            return `${word}(h)`;
                        }
                    })
                    .join("");
            }
        })
        .join(" (,) ");

    return (
        firstPartGabc +
        (omitFirstBreathMark ? "" : " (,) ") +
        secondPartGabc +
        (isLastLine ? " (::)" : " (:) ")
    );
});

console.log("GOSPEL", gabcPhrases);

export const RESURRECTION_GOSPEL = "(c3) " + gabcPhrases.join("");
